import React, { useState,useEffect } from 'react'
import { Button, Input, Select, Table ,Checkbox ,} from "antd";
import "aos/dist/aos.css";
import "../MainCSS.css";
import axios from "axios";
import { toast } from "react-toastify";
import { Option } from 'antd/es/mentions';
import DataTable from 'react-data-table-component'; // DataTable library
import { GetByOrderNumber, GetJobSheetApprovalList, GetJobSheetBulkApproval, GetJobSheetByOrderNumber } from '../../AllAPI/SalesAPI/SalesApi';
import { useLocation, useNavigate } from 'react-router-dom';

const JobSheetApproval = () => {
    const location = useLocation();
  const navigate = useNavigate();
  const commonHeaders = {
    headers: {
      createdBy: 1,
      updatedBy: 2,
      userIp: '',
      userLat: '',
      userLong: '',
      deviceSign: '',
    },
  };
 const [errors, setErrors] = useState({
       selectedId:"",

      });
    
  const goodTypesOptions = [
    { value: '1', label: 'F.T' },
    { value: '2', label: 'MM' },
    { value: '3', label: 'Inch' },
  ]
  const [allOrders, setAllOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orderItems, setOrderItems] = useState([]);
  const [approvedItems, setApprovedItems] = useState(new Set());
  const [selectAll, setSelectAll] = useState(false);
  const[selectedId , setSelectedId]=useState("");

  const[orderPass , setOrderPass]=useState(false);

   const [pageSize, setPageSize] = useState(10);
        const [filteredData, setFilteredData] = useState([]);
        const [currentPage, setCurrentPage] = useState(1);
        const [totalEntries, setTotalEntries] = useState(0);
        const [isBulkSelecting, setIsBulkSelecting] = useState(false);


   //======Search data from table===============
    const handleSearch = (value) => {
      const searchValue = value.toLowerCase();
  
      const filtered = orderItems.filter((item) =>
        Object.values(item).some((val) =>
          String(val ?? "").toLowerCase().includes(searchValue)
        )
      );

      setFilteredData(filtered);
      setTotalEntries(filtered.length); // Update total entries count after filtering
      setCurrentPage(1);
    };
  //==========Pagination=======================
  const handlePageSizeChange = (value) => {
    setPageSize(value);
  };
       // ==============Get  data================
      // let isJobApprovalFetched = false;
  // useEffect(() => {
  //   //if (isJobApprovalFetched) return;

  
  //   fetchJobSheetData();
  //   //isJobApprovalFetched = true;
  // }, []);
   useEffect(() => {
      fetchJobSheetData(); // Always fetch on first mount
  
      if (location.state?.refresh) {
        console.log("Refetching after return from approval page");
        fetchJobSheetData();
  
        // Remove refresh flag from location.state
        navigate(location.pathname, { replace: true, state: {} });
      }
    }, [location.state]);
  const fetchJobSheetData = async () => {
    try {
     // const response = await axios.get("http://192.168.29.1getJobSheetApprovalList16:8182/sales/JobSheetApproval/getJobSheetApprovalList",commonHeaders);
     const response = await axios.get(GetJobSheetApprovalList,commonHeaders);
      setAllOrders(response.data); // assuming the API returns an array
    } catch (error) {
      console.error("Error fetching Job Sheet data:", error);
      toast.error("Error fetching Job Sheet data");
    }
  };
 

  // const handleOrderSelect = async (orderId) => {
  //   const order = allOrders.find((o) => o.id === orderId);
  //   setSelectedOrder(order); 
  // };
  const toggleItemSelection = (itemId, isChecked) => {
    setApprovedItems((prev) => {
      const updated = new Set(prev);
      isChecked ? updated.add(itemId) : updated.delete(itemId);
  
      setIsBulkSelecting(updated.size > 1);
      return updated;
    });
  };
  
  const handleItemApproval = async (itemId , currentJobStatus) => {
    if (approvedItems.has(itemId)) {
      const newJobStatus = currentJobStatus === 0 ? 1 : (currentJobStatus === 1 ? 2 : 1);
            await approveItems([itemId],newJobStatus); // Wrap single ID in array
    } else {
      toast.warn("Please select the checkbox before approving.");
    }
  };
  
 
  
  const handleBulkApprove = async () => {
    const idsToApprove = Array.from(approvedItems);
  
    if (idsToApprove.length > 0) {
      const selectedStatuses = orderItems
        .filter((item) => approvedItems.has(item.id))
        .map((item) => item.jobStatus);
        
        const allApproved = selectedStatuses.every((status) => status === 1);
        const newStatus = allApproved ? 2 : 1;

  
      await approveItems(idsToApprove, newStatus);
  
      setApprovedItems(new Set());
      setSelectAll(false);
      setIsBulkSelecting(false);
      
    } else {
      toast.warn("No items selected for bulk action.");
    }
  };
     
    //========================================= For Bulk Approval /Rejection Button =====================================
    const selectedStatuses = orderItems
    .filter((item) => approvedItems.has(item.id))
    .map((item) => item.jobStatus);
  
  const bulkActionType = selectedStatuses.length > 0 && selectedStatuses.every((status) => status === 1)
    ? "reject"
    : "approve";
  
  const buttonText = bulkActionType === "approve" ? "Approve Selected Items" : "Reject Selected Items";
  const buttonColor = bulkActionType === "approve" ? "#28a745" : "#dc3545";
  //=======================================================================================
  
  const approveItems = async (orderNumberIds ,jobStatus) => {
    const requestBody ={
        id : orderNumberIds,
        jobStatus:1,
    }
    // const requestBody = orderNumberIds.map((orderNumber) => ({
    //   finalOrderNumber: orderNumber,  
    //   orderNumberId: selectedId,     
    //   itemApproval: 1 ,               
    // }));

    try {
      const response = await axios.post(
       `${GetJobSheetBulkApproval}?ids=${orderNumberIds}&jobStatus=${jobStatus}`,null,commonHeaders
      );
  
      if (response.data === "OK") {
        const action = jobStatus === 1 ? "Approved" : "Rejected";
        toast.success(`${action} successfully!`);
        handleSubmitOrder(selectedId);
        // setSelectedOrder(null);
        // setOrderItems([]);
        // setApprovedItems(new Set());
        // fetchJobSheetData();
       
      } else if (response.data === "alreadyexisted") {
        toast.warn("Item(s) already approved!");
      }
    } catch (error) {
      console.error("Error during approval:", error);
      toast.error("Error occurred while approving item(s)");
    }
  };
  

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);
    setIsBulkSelecting(checked); // update bulk selecting state
    if (checked) {
      const allIds = orderItems.map((item) => item.id);
      setApprovedItems(new Set(allIds));
    } else {
      setApprovedItems(new Set());
    }
  };
//   const columns1 = [
//   {
//     name: "Sr. No",
//     selector: (row, index) => (currentPage - 1) * pageSize + index + 1,
//     width: "80px",
//     sortable: false,
//   },
//   {
//     name: <div>Item Entry<br/> Date</div>,
//     selector: (row) => {
//       if (!row.itemEntryDate) return "-";
//       const [year, month, day] = row.itemEntryDate.split("-");
//       return `${day}/${month}/${year}`;
//     },
//     sortable: true,
//   },
//   {
//     name: "Item Name",
//     selector: (row) => row.dieName,
//     sortable: true,
//   },
//   {
//     name: "Alloy",
//     selector: (row) => row.alloyname,
//     sortable: true,
//   },
//   {
//     name: "Temper",
//     selector: (row) => row.temperName,
//     sortable: true,
//   },
//   {
//     name: "Wt. Range",
//     selector: (row) => row.weightRange,
//     sortable: true,
//   },
//   {
//     name: "Length",
//     selector: (row) => row.length,
//     sortable: true,
//        cell: row => {
//   const unitOption = goodTypesOptions.find(opt => opt.value === String(row.unit));
//   const unitLabel = unitOption ? `(${unitOption.label})` : "";
//   return `${row.length ?? ''} ${unitLabel}`;
// }
//   },
//   //  {
//   //     name: 'Unit',
//   //     selector: (row) => {
//   //       const unitOption = goodTypesOptions.find((opt) => opt.value === String(row.unit));
//   //       return unitOption ? unitOption.label : ''; // e.g., 'MM' or 'Inch'
//   //     },
//   //   }, 
//   {
//     name: "Pcs",
//     selector: (row) => row.pcs,
//     sortable: true,
//   },
//   {
//     name: "Qty (Kgs.)",
//     selector: (row) => row.qty,
//     sortable: true,
//   },
//   {
//     name: <div>Item <br/> Approval</div>,
//     selector: (row) => {
//       if (row.jobStatus === 1) return "Approved";
//       if (row.jobStatus === 2) return "Rejected";
//       return "Pending";
//     },
//     sortable: true,
//   },
//   {
//     name: (
//       <span>
//         Select All <Checkbox checked={selectAll} onChange={handleSelectAll} />
//       </span>
//     ),
//     cell: (row) => (
//       <Checkbox
//         checked={approvedItems.has(row.id)}
//         onChange={(e) => toggleItemSelection(row.id, e.target.checked)}
//       />
//     ),
//     ignoreRowClick: true,
//     allowOverflow: true,
//     button: true,
//   },
//   {
//     name: "Approve",
//     cell: (row) => (
//       <Button
//         style={{
//           backgroundColor: row.jobStatus === 1 ? "#dc3545" : "#007bff",
//           color: "#fff",
//         }}
//         onClick={() => handleItemApproval(row.id, row.jobStatus)}
//       >
//         {row.jobStatus === 1 ? "Reject" : "Approve"}
//       </Button>
//     ),
//     ignoreRowClick: true,
//     allowOverflow: true,
//     button: true,
//   },
// ];
//   const columns = [
// {
//   title: "Sr. No",
//     key: "serial",
//     render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
//   },
//     {
//       title: "Item Entry Date",
//       dataIndex: "itemEntryDate",
//       key: "itemEntryDate",
//       render: (date) => {
//         if (!date) return "-";
//         const [year, month, day] = date.split("-");
//         return `${day}/${month}/${year}`;
//       },
//     },
//     {
//       title: "Item Name",
//       dataIndex: "dieName",
//       key: "dieName",
//     },
//     {
//       title: "Alloy",
//       dataIndex: "alloyname",
//       key: "alloyname",
//     },
//     {
//       title: "Temper",
//       dataIndex: "temperName",
//       key: "temperName",
//     },
//     {
//       title: "Wt. Range",
//       dataIndex: "weightRange",
//       key: "weightRange",
//     },
//     {
//       title: "Length",
//       dataIndex: "length",
//       key: "length",
//     },
//     {
//       title: "Pcs",
//       dataIndex: "pcs",
//       key: "pcs",
//     },
//     {
//       title: "Quantity (Kgs.)",
//       dataIndex: "qty",
//       key: "qty",
//     },
//     {
//       title: "Item Approval",
//       dataIndex: "jobStatus",
//       key: "jobStatus",
//       render: (jobStatus) => {
//         if (jobStatus === 1) {
//           return "Approved";
//         } else if (jobStatus === 2) {
//           return "Rejected";
//         } else {
//           return "Pending"; // For jobStatus === 0
//         }
//       },
//     },
//     {
//       title: (
//         <span>
//           Select All <Checkbox checked={selectAll} onChange={handleSelectAll} />
//         </span>
//       ),
//       key: "select",
//       render: (_, record) => (
//         <Checkbox
//      checked={approvedItems.has(record.id)}
//       onChange={(e) => toggleItemSelection(record.id, e.target.checked)}

//         />
//       ),
//     },
//     {
//       title: "Approve",
//       key: "approve",
//       render: (_, record) => (
//         <Button
//            style={{
//     backgroundColor: record.jobStatus === 1 ? "#dc3545" : "#007bff", // Blue for Approved, Red for Rejected
//     color: "#fff",
//   }}

//          onClick={() =>
//         handleItemApproval(record.id , record.jobStatus)
//       }
//         >
//         {record.jobStatus === 1 ? "Reject" : "Approve"}
       
//         </Button>
//       ),
//     },
//   ];
  

  
   const components = {
        header: {
          cell: ({ children, ...restProps }) => (
            <th
              {...restProps}
              style={{
                backgroundColor: "#023e7d",
                color: "#fff",
                padding: "10px",
                fontSize: "15px",
                borderRadius: "0px",
              }}
            >
              {children}
            </th>
          ),
        },
        body: {
          row: ({ children, ...restProps }) => (
            <tr
              {...restProps}
              style={{
                backgroundColor: "#f0f7fd",
              }}
            >
              {children}
            </tr>
          ),
          cell: ({ children, ...restProps }) => (
            <td
              {...restProps}
              style={{
                padding: "8px",
            fontSize: '15px',
              }}
            >
              {children}
            </td>
          ),
        },
      };
const columns = [
  {
    title: "Sr. No",
    key: "serial",
    render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Item Entry Date",
    dataIndex: "itemEntryDate",
    key: "itemEntryDate",
    sorter: (a, b) =>
      new Date(a.itemEntryDate ?? '1970-01-01') - new Date(b.itemEntryDate ?? '1970-01-01'),
    render: (date) => {
      if (!date) return "-";
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
  },
  {
    title: "Item Name",
    dataIndex: "dieName",
    key: "dieName",
    sorter: (a, b) => (a.dieName ?? "").localeCompare(b.dieName ?? ""),
  },
  {
    title: "Alloy",
    dataIndex: "alloyname",
    key: "alloyname",
    sorter: (a, b) => (a.alloyname ?? "").localeCompare(b.alloyname ?? ""),
  },
  {
    title: "Temper",
    dataIndex: "temperName",
    key: "temperName",
    sorter: (a, b) => (a.temperName ?? "").localeCompare(b.temperName ?? ""),
  },
  {
    title: "Wt./R",
    dataIndex: "weightRange",
    key: "weightRange",
        render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,

    sorter: (a, b) => (a.weightRange ?? "").localeCompare(b.weightRange ?? ""),
  },
  {
    title: "Length",
    dataIndex: "length",
    key: "length",
        render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,

    sorter: (a, b) => (a.length ?? 0) - (b.length ?? 0),
  },
  {
    title: "Pcs",
    dataIndex: "pcs",
    key: "pcs",
        render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,

    sorter: (a, b) => (a.pcs ?? 0) - (b.pcs ?? 0),
  },
  {
    title: "Quantity (Kgs.)",
    dataIndex: "qty",
    key: "qty",
        render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,

    sorter: (a, b) => (a.qty ?? 0) - (b.qty ?? 0),
  },
  {
    title: "Item Approval",
    dataIndex: "jobStatus",
    key: "jobStatus",
    sorter: (a, b) => (a.jobStatus ?? 0) - (b.jobStatus ?? 0),
    render: (jobStatus) => {
      if (jobStatus === 1) return "Approved";
      if (jobStatus === 2) return "Rejected";
      return "Pending";
    },
  },
  {
    title: (
      <span>
        Select All <Checkbox checked={selectAll} onChange={handleSelectAll} />
      </span>
    ),
    key: "select",
    render: (_, record) => (
      <Checkbox
        checked={approvedItems.has(record.id)}
        onChange={(e) => toggleItemSelection(record.id, e.target.checked)}
      />
    ),
  },
  {
    title: "Approve",
    key: "approve",
    render: (_, record) => (
      <Button
        style={{
          backgroundColor: record.jobStatus === 1 ? "#dc3545" : "#007bff",
          color: "#fff",
        }}
        onClick={() => handleItemApproval(record.id, record.jobStatus)}
      >
        {record.jobStatus === 1 ? "Reject" : "Approve"}
      </Button>
    ),
  },
];


      let isError = false;
      const handleSubmitOrder = async (orderId) => {
        // const order = allOrders.find((o) => o.id  === orderId);
        // setSelectedOrder(order); 
console.log(selectedOrder);
        let isValid = true;
        const errorObj = {};
      
        // Validation: Ensure selectedId is present and valid
        if (!selectedId || (typeof selectedId === 'string' && !selectedId.trim())) {
          isValid = false;
          errorObj.orderId = "Order ID is required *";
        }
      
        setErrors(errorObj); // Set error messages
        if (!isValid) return;
      
        try {
          // API Call: Fetch order details using selected ID
          const response = await axios.get(
            `${GetJobSheetByOrderNumber}?orderNumberId=${orderId}`,
            commonHeaders
          );
      
          const orderDetails = response.data;
      
          if (!orderDetails) {
            toast.error("Failed to fetch order details.");
            return;
          }
      
      
          // You can now process or submit the orderDetails further
          if (Array.isArray(orderDetails) && orderDetails.length > 0) {
            setOrderItems(orderDetails);
            setFilteredData(orderDetails);
            setTotalEntries(orderDetails.length);
            const order = allOrders.find((o) => o.id  === orderId);
            setSelectedOrder(order); 
    //            localStorage.setItem("selectedOrderData", JSON.stringify({
    //   orderInfo: order,
    //   selectedItems: orderDetails,
    // }));
     window.open(`#/jobsheet-details/${orderId}`, "_blank");
          } else {
            toast.warn("No items found for the selected order.");
            setOrderItems([]);  // Clear order items
            setFilteredData([]);  // Clear filtered data (this will reset the table display)
            setTotalEntries(0);  // Reset total entries count
          }
        } catch (error) {
          console.error("Error during order submission:", error);
          toast.error("An error occurred while processing the order.");
        }
      };

  return (
    <div className="px-5 py-3" style={{ fontSize: "15px" }}>
 <div  className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' ,minHeight: '800px'  }}>
          
  <div className="col-12">


    <div className="p-0 m-0">
   <div className="row px-md-5 mt-3 p-2">
      <div className="row p-0 m-0">
        <div className="col-12 col-lg-4"></div>
        <div className="row justify-content-center">

        <div className="col-12 col-lg-6">
          <div className="row p-0 m-0">
           
              <div className="col-12 py-1">
                <label className="labels">Select Order</label>
                <Select
                  showSearch
                  placeholder="Select an Order"
                  value={selectedId}
                  onChange={(value) => {
                 setSelectedId(value);
                // handleSubmitOrder(value);
                }}
                 // onChange={handleOrderSelect}
                  style={{ width: "100%" }}
                  optionFilterProp="children"
                >
                  {/* {allOrders.map((order) => (
                    <Option key={order.id} value={order.id}>
      {order.jobStatus === 0 ? (
        <span style={{ color: "red", fontWeight: "bold" }}>🔴</span>
      ) : <span></span>}
      {order.orderNumber} | {order.customerName} | {order.entryDate}  | {order.poNumber}| {order.poDate}  
    </Option>
                  ))} */}
                            {[...allOrders]
                              .sort((a, b) => {
                                if (a.jobStatus === 0 && b.jobStatus !== 0) return -1;
                      if (a.jobStatus !== 0 && b.jobStatus === 0) return 1;

                    // Helper: convert 'dd/mm/yyyy' to Date object
                    const parseDMY = (dateStr) => {
                      {/* const [day, month, year] = dateStr.split("/");
                      return new Date(`${year}-${month}-${day}`);
                    }; */}
                      if (!dateStr || typeof dateStr !== 'string') return new Date(0); // safe fallback
    const [day, month, year] = dateStr.split('/');
    return new Date(`${year}-${month}-${day}`);
  };
                  
                    const today = new Date();
                    const aDate = parseDMY(a.entryDate);
                    const bDate = parseDMY(b.entryDate);
                  
                    const isAToday = aDate.toDateString() === today.toDateString();
                    const isBToday = bDate.toDateString() === today.toDateString();
                  
                    if (isAToday && !isBToday) return -1;
                    if (!isAToday && isBToday) return 1;
                  
                    if (a.status === 0 && b.status !== 0) return -1;
                    if (a.status !== 0 && b.status === 0) return 1;
                  
                    // fallback: newest first
                    return bDate - aDate;
                  })
                  
                      .map((order) => {
                        const labelText = `${order.orderNumber} | ${order.customerName} | ${order.entryDate} | ${order.poNumber} | ${order.poDate}`;
                        return (
                          <Option key={order.id} value={order.id} label={labelText}>
                          {order.jobStatus === 0 ? (
        <span style={{ color: "red", fontWeight: "bold" }}>🔴</span>
      ) : <span></span>}
                            {labelText}
                          </Option>
                        );
                      })}
                </Select>
                {/* Submit button */}
                <div className="mt-2 text-center">                 
                 <Button
                  type="button"
                className="SubmitBtn mx-1"
                onClick={()=>{
                  handleSubmitOrder(selectedId);
                  //handleOrderSelect(selectedId);
                }} 

                  >
                    Submit Selected Order
                  </Button>
                </div>
              </div>
          
          </div>
        </div></div>
        <div className="col-12 col-lg-4"></div>
      </div>


        {/* {selectedOrder && (
          <>
          <div className="shadow border p-4 mb-4" style={{ backgroundColor: "#f8f9fa", fontSize: "15px"}}>
          <div className="order-summary my-3 px-4">
  <h6 className="mb-3" style={{fontSize: "17px"}}>Order Details:</h6>
  <div className="container-fluid">
    <div className="row" style={{fontSize: "17px"}}>
      {/* Left column 
        <div className="col-md-4">
        <div className="d-flex mb-3"  style={{fontSize: "17px"}}>
          <span style={{ minWidth: "110px", marginRight: "10px" }}>Order Number:</span>
          <strong>{selectedOrder.orderNumber}</strong>
        </div>
        <div className="d-flex">
          <span style={{ minWidth: "110px", marginRight: "10px" }}>PO No.:</span>
          <strong>{selectedOrder.poNumber}</strong>
        </div>
      </div>

      {/* Right column 
       <div className="col-md-4">
        
          <div className="d-flex mb-3"  style={{fontSize: "17px"}}>
          <span style={{ minWidth: "130px", marginRight: "10px" }}>Order Entry Date:</span>
          <strong>{selectedOrder.entryDate}</strong>
        </div>
        <div className="d-flex">
          <span style={{ minWidth: "130px", marginRight: "10px" }}>Customer:</span>
          <strong>{selectedOrder.customerName}</strong>
        </div>
      </div>
      <div className="col-md-4">
        <div className="d-flex mb-3"  style={{fontSize: "17px"}}>
          <span style={{ minWidth: "130px", marginRight: "10px" ,fontSize: "17px" }}>PO Date:</span>
          <strong   style={{fontSize: "17px"}}>{selectedOrder.poDate}</strong>
        </div>
</div>
    </div>
  </div>
</div></div>
          </>
        )}*/}
      </div> 

      {/* Table */}
      {/* {selectedOrder && (
         <div className="row m-0 p-2  px-md-5 pt-md-0 mt-3">
               <div className="col-12 py-3 shadow border" style={{  backgroundColor: "white" }}>
                 <div className="col-12 px-md-5" style={{ display: "flex", justifyContent: "space-between" }}>
                   <div>
                     {/* <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                     <Select
                       defaultValue={pageSize}
                       onChange={handlePageSizeChange}
                       style={{ width: 120, textAlign: "center" }}
                     >
                       <Option value={10}>10</Option>
                       <Option value={20}>20</Option>
                       <Option value={30}>30</Option>
                     </Select> */}
                       {/* <div>
          Show{" "}
          <Select
            value={pageSize}
            onChange={(value) => setPageSize(value)}
            style={{ width: 80 }}
          >
            {[5, 10, 15, 20, 25, 50].map((size) => (
              <Option key={size} value={size}>
                {size}
              </Option>
            ))}
          </Select>{" "}
          entries
        </div> 
                   </div>
           
                   <div className="pt-4 pt-md-0">
                     <Input.Search
                       placeholder="Search"
                        onChange={(e) => handleSearch(e.target.value)}
                       style={{ width: 200, marginBottom: 16 }}
                     />
                   </div>
                 </div>
           
                 <div style={{ backgroundColor: "white" }}>
                   <Table
                     bordered
                     style={{ padding: "0px 20px", overflowX: "auto" }}
                     columns={columns}
                     dataSource={filteredData}
                     pagination={{
                       pageSize: pageSize,
                       total: totalEntries,
                       showTotal: (total, range) =>
                         `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                       current: currentPage,
                       onChange: (page) => setCurrentPage(page),
                     }}
                     showSorterTooltip={false}
                     rowKey={(record) => record.id}
                     components={components}
                       footer={() => {
    const totalPcs = filteredData.reduce((sum, item) => sum + (item.pcs || 0), 0);
    const totalQty = filteredData.reduce((sum, item) => sum + (item.qty || 0), 0);
    return (
      <div style={{ display: "flex", justifyContent: "flex-end", fontWeight: "bold" }}>
        <div style={{ marginRight: "20px" }}>Total Pcs: {totalPcs}</div>
        <div>Total Qty (Kgs.): {totalQty}</div>
      </div>
    );
  }}
                   />
{/* <DataTable
  columns={columns1}
  data={filteredData}
  pagination
  paginationPerPage={pageSize}

  onChangePage={(page) => setCurrentPage(page)}
    paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 50]} // optional
  onChangeRowsPerPage={(newPageSize) => {
    setPageSize(newPageSize);
    setCurrentPage(1); // reset to first page when page size changes
  }}
  paginationTotalRows={filteredData.length}
  highlightOnHover
  striped
  responsive
  customStyles={{
    headCells: {
      style: {
        backgroundColor: "#023e7d",
        color: "#fff",
        padding: "10px",
        fontSize: "14px",
      },
    },
    rows: {
      style: {
        backgroundColor: "#f0f7fd",
        fontSize: "14px",
      },
    },
    cells: {
      style: {
        padding: "8px",
      },
    },
  }}
/> 

                 </div>

                 {isBulkSelecting && approvedItems.size > 1 && (
  <div className="text-center px-md-5 mb-3">
    <Button
      onClick={handleBulkApprove}
      style={{
        backgroundColor: buttonColor,
        borderColor: buttonColor,
        color: "#fff",
      }}
    >
      {buttonText}
    </Button>
  </div>
)}

               </div>
               <div className="text-center pt-3">
              <Button
                 type="submit"
                className="CancelBtn mx-1"
                onClick={() => {
                  setSelectedOrder(null);
                  setOrderItems([]);
                  setApprovedItems(new Set());
                  fetchJobSheetData();
                }}
              >
               Back to Page
              </Button>
            </div>
             </div>
      )} */}
     
    </div>
    </div></div></div>
  );
};

export default JobSheetApproval;